import htmx from 'htmx.org';

const forms = document.querySelectorAll('form');
if (forms.length > 0) {
    // Loop through forms
    for (let form of forms) {
        // Get all inputs for validation
        var inputs = form.querySelectorAll<HTMLInputElement>("input, select, textarea");
        //Block submit form if needed
        form.addEventListener('submit', submitForm.bind(form));
        let formhasError = false;
        // Loop through inputs
        inputs.forEach(input => {
            // Add input event to all inputs and listen to inputChange function
            input.addEventListener('change', validateInputListener);
            // if has error class
            if (!formhasError && input.classList.contains("input-error")) {
                formhasError = true;
                MakeErrorInputVisible(input);
            }
        });
    }
}

htmx.onLoad((content) => {
    var inputs = (content as HTMLElement).querySelectorAll<HTMLInputElement>("input, select, textarea");
    inputs.forEach(input => {
        // Add input event to all inputs and listen to inputChange function
        input.addEventListener('change', validateInputListener);
    });
});

function validateInputListener(this: HTMLInputElement): void {
    validateInput(this);
}

function validateInput(input: HTMLInputElement): boolean {
    const validate = input.getAttribute('data-validate') || 'true';
    clearRequiredHighlight(input);
    if (validate === 'false') {
        return true;
    }
    if (!input.validity.valid) {
        var validationMessage = "";
        if (input.validity.valueMissing) {
            if (input.type === "radio") {
                validationMessage = input.closest<HTMLElement>('.input-parent-container')?.dataset.requiredMsg ?? ""
            }
            else if (input.type === "checkbox") {
                if (!validateRequiredCheckboxGroup(input)) {
                    validationMessage = input.closest<HTMLElement>('.input-parent-container')?.dataset.requiredMsg ?? ""
                } else {
                    clearHighlightInput(input);
                    return true;
                }
            }
            else {
                validationMessage = input.dataset.requiredMsg ?? "";
            }
        } else if (input.validity.tooShort) {
            validationMessage = input.dataset.minlengthMsg ?? "";
        } else if (input.validity.tooLong) {
            validationMessage = input.dataset.maxlengthMsg ?? "";
        } else if (input.validity.rangeOverflow) {
            validationMessage = input.dataset.betweenMsg ?? input.dataset.maxMsg ?? "";
        } else if (input.validity.rangeUnderflow) {
            validationMessage = input.dataset.betweenMsg ?? input.dataset.minMsg ?? "";
        } else if (input.validity.patternMismatch) {
            validationMessage = input.dataset.patternMsg ?? "";
        }
        if (validationMessage === "") {
            validationMessage = "Input error";
        }
        highlightErrorInput(input, validationMessage);
        return false;
    } else {
        clearHighlightInput(input);
        return true;
    }
}

function highlightErrorInput(input: HTMLInputElement, errorMessage: string) {
    var errorElement = getErrorMessageElement(input, true) as HTMLElement;
    errorElement.classList.add('input-error-message');
    errorElement.innerText = errorMessage;
    if (input.type !== "radio" && input.type !== "checkbox") {
        input.classList.add('input-error');
        input.parentElement?.classList.add('input-error-parent');
    } else {
        input.closest("fieldset")?.classList.add('input-error-parent');
    }
    switch (input.type) {
        case "text":
        case "number":
        case "password":
        case "textarea":
            input.addEventListener('input', errorInputEvent);
            break;
        default:
            input.addEventListener('change', errorChangeEvent);
            break;
    }
}

function clearHighlightInput(input: HTMLInputElement) {
    var errorElement = getErrorMessageElement(input, false);
    input.classList.remove('input-error');
    if (input.type !== "radio" && input.type !== "checkbox") {
        input.parentElement?.classList.remove('input-error-parent');
    } else {
        input.closest("fieldset")?.classList.remove('input-error-parent');
    }
    input.parentElement?.classList.remove('input-error-parent');
    if (errorElement) {
        errorElement.remove();
    }
}

function clearRequiredHighlight(input: HTMLInputElement) {
    const requiredMessageElement = getRequiredMessageElement(input);
    input.classList.remove("input-required");
    if (requiredMessageElement) {
        requiredMessageElement.remove();
    }
}

function errorInputEvent(this: HTMLInputElement) {
    if (validateInput(this) == null) {
        this.removeEventListener("input", errorInputEvent);
    }
}

function errorChangeEvent(this: HTMLInputElement) {
    if (validateInput(this) == null) {
        this.removeEventListener("change", errorChangeEvent);
    }
}

function getErrorMessageElement(input: HTMLInputElement, createElement: boolean): HTMLElement | undefined | null {
    var inputID = input.getAttribute("name") ?? input.id;
    if (inputID == "") {
        inputID = input.id;
    }
    var errorElement: HTMLElement | undefined | null = null;
    if (input.parentElement) {
        errorElement = input.closest<HTMLElement>(".input-parent-container")?.querySelector<HTMLElement>(".input-error-message");
    }
    if (!errorElement && createElement) {
        errorElement = document.createElement("span");
        if (input.type === "radio" || input.type === "checkbox") {
            input.closest("fieldset")?.querySelector<HTMLElement>("legend")?.insertAdjacentElement("beforebegin", errorElement);
        } else {
            input.insertAdjacentElement("beforebegin", errorElement);
        }
    }
    return errorElement
}

function getRequiredMessageElement(input: HTMLInputElement): HTMLElement | undefined | null {
    const inputID = input.getAttribute("name") ?? input.id;
    let requiredElement: HTMLElement | undefined | null = null;
    if (input.parentElement) {
        requiredElement = input.closest<HTMLElement>(".input-parent-container")?.querySelector<HTMLElement>(`#${inputID}-required`);
    }
    return requiredElement;
}

function submitForm(this: HTMLFormElement, e: Event): boolean {
    var inputs = this.querySelectorAll<HTMLInputElement>("input, select, textarea");
    let hasError = false;
    inputs.forEach(input => {
        if (!validateInput(input)) {
            e.preventDefault();
            if (!hasError) {
                hasError = true;
                MakeErrorInputVisible(input);
            }
        }
    });
    return !hasError;
}

function validateRequiredCheckboxGroup(input: HTMLInputElement): boolean {
    const checkboxes = input.closest('fieldset')?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');
    let isChecked = false;
    // Loop through radios and check if any radio is checked and if it is checked set isChecked to true
    if (checkboxes) {
        for (let checkbox of checkboxes) {
            if (!checkbox.validity.valueMissing) {
                return true;
            }
        }
    }
    return false;
}

function MakeErrorInputVisible(input: HTMLInputElement) {
    input.parentElement?.scrollIntoView({ behavior: "smooth", block: "center" });
    input.focus();
}
